import { defineComponent as _defineComponent } from 'vue'
import {
	useRouter,
  useStore,
  computed,
} from "@nuxtjs/composition-api";
import { useContactStore } from "~/composables/useContactDialog";
import { trackEvent } from "~/utils/track-event";
import useLoginDialog from '~/composables/useLoginDialog';
import { dayjs } from "~/utils/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const { open } = useContactStore();
const onOpenChat = () => {
  open();
  trackEvent("4");
};
const router = useRouter()
const store = useStore();
const loggedIn = computed(() => store.getters.loggedIn);
const { showLogin } = useLoginDialog()

const feedback = () => {
  if(loggedIn.value){
    router.push('/feedback')
  } else {
    showLogin()
  }
}

const yearDate = computed(()=>{
  return dayjs().format("YYYY");
})

return { __sfc: true,open, onOpenChat, router, store, loggedIn, showLogin, feedback, yearDate }
}

})